<script>
	export let tip = '';
	let isHovered = false;
	let x;
	let y;

	function mouseOver(event) {
		isHovered = true;
		x = event.pageX + 5;
		y = event.pageY + 15;
	}
	function mouseMove(event) {
		x = event.pageX + 5;
		y = event.pageY + 15;
	}
	function mouseLeave() {
		isHovered = false;
	}
</script>

<button
	class="sb-tooltip"
	on:mouseover={mouseOver}
	on:focus={mouseOver}
	on:mouseleave={mouseLeave}
	on:mousemove={mouseMove}
	on:blur={mouseLeave}
>
	<slot>
		<svg width="20" height="20" viewBox="0 0 24 24">
			<path
				d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
			/>
		</svg>
	</slot>
</button>

{#if isHovered}
	<div class="sb-tooltip-content" style="top: {y}px; left: {x}px;">
		{@html tip}
	</div>
{/if}

<style>
	.sb-tooltip {
		display: inline-block;
		background: none;
		border: none;
		padding: 0;
		margin: 0;
		border-radius: 50%;
	}

	.sb-tooltip-content {
		border: 1px solid #ddd;
		box-shadow: 1px 1px 1px #ddd;
		background: white;
		border-radius: 4px;
		padding: 4px;
		position: fixed;
		max-width: 240px;
		transform: translateX(-50%);
		white-space: pre-wrap !important;
		z-index: 101;
	}
</style>
